import React from 'react';
import { Button } from '../ui/Button';
import { Accordion } from '../ui/Accordion';
import { Shield, Clock, Mail } from 'lucide-react';
export function PricingFAQ() {
  const faqs = [{
    title: '¿Necesito conocimientos previos de química?',
    content: 'No, en absoluto. El método está diseñado para principiantes. Explicamos cada término desde cero y las fórmulas son fáciles de seguir si respetas el orden indicado.'
  }, {
    title: '¿Dónde consigo los ingredientes?',
    content: 'La mayoría de los ingredientes (aceites, mantecas, ceras) se consiguen en tiendas naturistas locales o Amazon. En el libro te damos una guía de qué buscar en las etiquetas.'
  }, {
    title: '¿Necesito utensilios costosos?',
    content: 'No. Para empezar solo necesitas una balanza digital de cocina (muy económica), recipientes de vidrio resistentes al calor y una batidora pequeña o espumador. Probablemente ya tengas casi todo en tu cocina.'
  }, {
    title: '¿El libro es físico o digital?',
    content: 'Es un producto 100% digital (eBook en formato PDF). Lo recibes en tu correo electrónico inmediatamente después de la compra para que puedas leerlo en tu celular, tablet o computadora, o imprimirlo si prefieres.'
  }, {
    title: '¿En qué moneda está el precio?',
    content: 'El precio es de $6.36 Dólares Americanos (USD). La plataforma de pago hará la conversión automática a tu moneda local al tipo de cambio del día.'
  }, {
    title: '¿Las fórmulas son seguras para pieles sensibles?',
    content: "Sí, la cosmética natural suele ser muy amable. Además, enseñamos cómo hacer la 'prueba de parche' y cómo ajustar ingredientes si tienes alguna alergia específica (por ejemplo, sustituir aceite de almendras si eres alérgica a los frutos secos)."
  }, {
    title: '¿Puedo vender los productos que haga?',
    content: '¡Sí! Muchas de nuestras alumnas empiezan haciendo productos para ellas y terminan vendiendo a amigos y familiares. El módulo de negocio y etiquetas te ayudará a dar una imagen profesional.'
  }, {
    title: '¿Cuánto tiempo tengo acceso al libro?',
    content: 'El acceso es de por vida. Una vez que lo descargas, es tuyo para siempre. Puedes guardarlo en tus dispositivos y consultarlo cuando quieras.'
  }];
  return <section className="py-20 bg-gradient-to-b from-white to-[#F5F2EA]" data-id="element-178">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-179">
        {/* PRICING CARD */}
        <div id="offer" className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100 mb-24" data-id="element-180">
          <div className="bg-[#4A6741] p-4 text-center" data-id="element-181">
            <p className="text-white font-bold tracking-wider text-sm uppercase" data-id="element-182">
              Oferta por tiempo limitado
            </p>
          </div>
          <div className="p-8 md:p-12 text-center" data-id="element-183">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-184">
              Empieza tu laboratorio natural hoy mismo
            </h2>
            <p className="text-gray-600 mb-8 max-w-lg mx-auto" data-id="element-185">
              Acceso completo al Método Natural Care + Todas las fórmulas +
              Guías de seguridad.
            </p>

            <div className="flex items-center justify-center gap-4 mb-8" data-id="element-186">
              <div className="text-gray-400 line-through text-2xl" data-id="element-187">$27.00</div>
              <div className="text-5xl md:text-6xl font-bold text-[#C06C54]" data-id="element-188">
                $6.36
              </div>
              <div className="text-gray-500 font-medium self-end mb-2" data-id="element-189">USD</div>
            </div>

            <div className="max-w-md mx-auto space-y-4 mb-10" data-id="element-190">
              <Button variant="urgent" size="xl" fullWidth withMicrocopy data-id="element-191">
                DESCARGAR AHORA
              </Button>
              <p className="text-xs text-center text-gray-500" data-id="element-192">
                Pago seguro procesado por Hotmart/Stripe. Tus datos están
                protegidos.
              </p>
            </div>

            <div className="grid grid-cols-3 gap-4 border-t border-gray-100 pt-8" data-id="element-193">
              <div className="flex flex-col items-center gap-2" data-id="element-194">
                <Clock className="w-6 h-6 text-[#4A6741]" data-id="element-195" />
                <span className="text-xs md:text-sm font-medium text-gray-600" data-id="element-196">
                  Entrega Inmediata
                </span>
              </div>
              <div className="flex flex-col items-center gap-2" data-id="element-197">
                <Mail className="w-6 h-6 text-[#4A6741]" data-id="element-198" />
                <span className="text-xs md:text-sm font-medium text-gray-600" data-id="element-199">
                  Acceso por Email
                </span>
              </div>
              <div className="flex flex-col items-center gap-2" data-id="element-200">
                <Shield className="w-6 h-6 text-[#4A6741]" data-id="element-201" />
                <span className="text-xs md:text-sm font-medium text-gray-600" data-id="element-202">
                  Compra Segura
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* FAQ */}
        <div className="mb-20" data-id="element-203">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-10" data-id="element-204">
            Preguntas Frecuentes
          </h2>
          <Accordion items={faqs} data-id="element-205" />
        </div>

        {/* FINAL CTA */}
        <div className="text-center max-w-2xl mx-auto" data-id="element-206">
          <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-207">
            ¿Lista para crear productos que tu piel amará?
          </h3>
          <p className="text-gray-600 mb-8" data-id="element-208">
            No dejes pasar la oportunidad de aprender una habilidad para toda la
            vida por el precio de un café.
          </p>
          <Button variant="primary" size="lg" className="w-full md:w-auto px-12" withMicrocopy data-id="element-209">
            QUIERO EMPEZAR HOY
          </Button>
        </div>
      </div>
    </section>;
}